module.exports = __webpack_public_path__ + "img/logo.89fd621b.png";